import { linkItems } from "@/components/Header/types/LinkItemsCollection";

export const useRedirectToLogin = (): void => {
    const {$router} = useNuxtApp();
    const url = linkItems.login.routerPath;
    void $router.push(url);
}